import React, { Component } from 'react';

import Single from './Single';
// import { Link } from 'react-router-dom';

export default class RenderSingle extends Component {
    renderPosts(posts) {
        const post = posts[0];
        if (this.props.posts.fetched) {
            let hasFeaturedImage = null;
            if (post.better_featured_image) {
                hasFeaturedImage =
                    post.better_featured_image.media_details.sizes;
                // console.log(hasFeaturedImage)
            }
            return (
                <Single
                    key={post.id}
                    acf={post.acf || []}
                    type={post.type}
                    pId={post.id}
                    title={post.title.rendered}
                    content={post.content.rendered}
                    date={post.date}
                    formattedDate={post.formatted_date}
                    link={post.link}
                    featuredImage={hasFeaturedImage}
                    categories={post.categories}
                    tags={post.tags || []}
                    links={post._links}
                />
            );
        }
    }

    render() {
        return <div>{this.renderPosts(this.props.posts.posts)}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/RenderSingle.jsx